export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      phonebookLocations: [
        {
          locationId: 2,
          locationUuid: "videochatphonebook002",
          deviceSerial: "device-xxxxxxxxxx",
          modelNumber:"JS-02H",
          modelName:"hoambox",
          profile1: {
            order: 1,
            body: "相良　太郎",
          },
          status:2,
          display:0
        },
        {
          locationId: 1,
          locationUuid: "videochatphonebook001",
          deviceSerial: "device-xxxxxxxxxx",
          modelNumber:"JS-02H",
          modelName:"hoambox",
          profile1: {
            order: 1,
            body: "相良　太郎",
          },
          status:1,
          display:1
        }
      ]
    }
  }
}